import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {syncCurrentReport} from '../new-report/store';
import Loading from '../../components/style-guide/loading/Loading';
import {navigate} from '@reach/router';
import {AppRouters} from '../../settings';
import {registerAnalyticsEvent} from 'shared/utils/analytics';
import {Google_Analitys_Categories} from 'settings/data';

const ReportCheckout = ({actions, isReportSync, report, location}) => {
    const [loading, setLoader] = useState(false);
    const {cat_new_report, ga_actions} = Google_Analitys_Categories;

    useEffect(() => {
        const execEffect = async () => {
            setLoader(true);
            registerAnalyticsEvent({
                category: cat_new_report,
                action: ga_actions.checkout,
                label: 'start_payment_from_email',                
            })
            registerAnalyticsEvent({
                category: cat_new_report,
                action: ga_actions.report_id,
                label: location.state.reportId,                
            })

            if (!isReportSync) return actions.syncCurrentReport(location.state.reportId);

            if (!report) {
                console.log('Report was not persisted!');
                return await navigate(AppRouters.incompletePaymentError);
            }

            registerAnalyticsEvent({
                category: cat_new_report,
                action: ga_actions.success_checkout,
                label: 'payment_successfully',                
            })
            registerAnalyticsEvent({
                category: cat_new_report,
                action: ga_actions.report_id,
                label: location.state.reportId,                
            })
        };

        execEffect();
    }, [actions, report, isReportSync]);

    return (
        loading ? <Loading message="Procesando el pago ..."/> : <div/>
    );
};

const mapStateToProps = (state) => ({
    report: state.newReportReducers.reportPayload,
    isReportSync: state.newReportReducers.syncPending,
});

const mapDispatchToProps = dispatch => {
    return {
        actions: {
            syncCurrentReport: (reportId) => dispatch(syncCurrentReport(reportId)),
        },
        dispatch
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportCheckout);
